import React from 'react';
import CreateTransactionFormContainer from './CreateTransactionFormContainer';

const SalesFormBlock = (props) => {
  return (
    <CreateTransactionFormContainer />
  );
};

export default SalesFormBlock;


// WEBPACK FOOTER //
// ./src/modules/transaction/components/SalesFormBlock.js